export let PusherEventName = /*#__PURE__*/function (PusherEventName) {
  PusherEventName["InvoiceUpdated"] = "InvoiceUpdated";
  PusherEventName["PayoutXeroIntegrationStatusUpdated"] = "PayoutXeroIntegrationStatusUpdated";
  PusherEventName["PayoutQboIntegrationStatusUpdated"] = "PayoutQboIntegrationStatusUpdated";
  PusherEventName["RelationshipCreatedFromScheduledDraft"] = "RelationshipCreatedFromScheduledDraft";
  return PusherEventName;
}({});
export let InvoiceUpdatedType = /*#__PURE__*/function (InvoiceUpdatedType) {
  InvoiceUpdatedType["XeroIntegrationStatusUpdated"] = "XeroIntegrationStatusUpdated";
  InvoiceUpdatedType["QboIntegrationStatusUpdated"] = "QboIntegrationStatusUpdated";
  InvoiceUpdatedType["RefundFailed"] = "RefundFailed";
  InvoiceUpdatedType["Unvoided"] = "Unvoided";
  InvoiceUpdatedType["UnmarkedAsPaidExternally"] = "UnmarkedAsPaidExternally";
  return InvoiceUpdatedType;
}({});